<ng-container *ngIf="showHeader">
    <img class="banner-img center-block div-print" src="https://gestionatupyme-public.s3.amazonaws.com/banner.png" alt=""/>
</ng-container>

<mat-card class="simple-card mx-auto">
    <mat-card-content>
        <div class="row">

            <div class="col-12 d-flex justify-content-between" *ngIf="showHeader">
                <h1>Deuda Sbif Leasing</h1>
                <button mat-flat-button 
                    class="custom-button-primary no-print"
                    [printTitle]='"DeudaSbifLeasing_"+(rut | rutFormat)+"_"+today'
                    [useExistingCss]="true"
                    printSectionId="print-section"
                    ngxPrint
                    >
                    <mat-icon 
                        aria-hidden="false" 
                        aria-label="Icono de descarga" 
                        fontIcon="get_app" 
                        class="icon-download mr-3"
                    ></mat-icon>
                    Descargar Resultado
                </button>
            </div>

            <div class="col-12 my-3" *ngIf="showHeader">
                <mat-chip-set aria-label="Rut principal">
                <mat-chip class="chip-rut"><strong>RUT:</strong> 
                    <ng-template #buscar>
                        {{content?.Documentos?.SbifOnline?.DatosBasicosSolicitud?.Rut | number : '1.0-0'}}-
                        {{content?.Documentos?.SbifOnline?.DatosBasicosSolicitud?.DV | uppercase}}
                    </ng-template>
                    

                    <ng-container *ngIf="typeTX; else buscar">
                        {{content.DeudaSistemaFinancieroReporte?.DatosBasicosSolicitud?.Rut | number : '1.0-0'}}-
                        {{content.DeudaSistemaFinancieroReporte?.DatosBasicosSolicitud?.DV | uppercase}}
                    </ng-container>
                </mat-chip>
                </mat-chip-set>
            </div>

            <!--REPORTE-->
            <div class="col-12">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title class="font-size-title-card">
                            <mat-chip class="chip-info mr-3"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            <strong>Antecedentes M$</strong>
                        </mat-card-title>
                    </mat-card-header>
                    
                    <mat-card-content>

                        <div class="row p-5" *ngIf="dataSource.length > 0">
                            <div class="col-12 border px-0">
                                <div class="table-responsive">
                                    <table mat-table [dataSource]="dataSource" id="print-table">
                                        <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns; let i = index">
                                            <th mat-header-cell *matHeaderCellDef class="text-capitalize text-center"> {{ column != 'field'? (column | date: 'LLL yyyy'): '' }} </th>
                                            <td mat-cell *matCellDef="let element" [ngClass]="{'text-danger': column != 'field' ? putColor(element['field'], element[column]) : false, 'text-right': column != 'field'}"> {{
                                                column == 'field' ? (headNames[element[column]]) : (
                                                    element['field'] !== 'diracreedor' ? (element[column] | number : '1.0-0') : (
                                                        (element[column][0] | number : '1.0-0') + '/' + (element[column][1] | number : '1.0-0')
                                                    )
                                                )
                                            }} </td>
                                        </ng-container>
                                        
                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </mat-card-content>
                </mat-card>
            </div>

        </div>
    </mat-card-content>
</mat-card>
